import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "user-name" }
const _hoisted_2 = {
  key: 0,
  class: "nick-name"
}
const _hoisted_3 = { class: "email" }
const _hoisted_4 = {
  key: 1,
  class: "title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_VuePictureCropper = _resolveComponent("VuePictureCropper")!
  const _component_vue_cropper = _resolveComponent("vue-cropper")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_InformationDialog = _resolveComponent("InformationDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      class: _normalizeClass(_ctx.showPhotoRequired ? 'error-border' : '')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode(" Add a Profile Photo "),
            _createElementVNode("small", { class: "ml-2 error--text" }, "*", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "stretch" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "pt-0",
                  "align-self": "center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["image-container", { 'has-image': _ctx.personalDetailModel && _ctx.personalDetailModel.PhotoUrl }])
                    }, [
                      (_ctx.personalDetailModel && _ctx.personalDetailModel.PhotoUrl && !_ctx.isHiringmanager)
                        ? (_openBlock(), _createBlock(_component_v_img, {
                            key: 0,
                            class: "profile-image",
                            src: _ctx.personalDetailModel.PhotoUrl,
                            "aspect-ratio": "1",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imageDialog = true))
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createVNode(_component_v_col, {
                      md: "12",
                      class: "upload-button text-center"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              class: "secondary_btn pt-0",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadImage = !_ctx.uploadImage))
                            }, {
                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                _createTextVNode("Upload a Photo.")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.isHiringmanager)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 1,
                              icon: "",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPhotoRequirements = true))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                                    _createTextVNode("mdi-information-variant")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "mt-0" }, {
              default: _withCtx(() => [
                (_ctx.personalDetail)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      align: "center",
                      class: "pt-0"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.personalDetail.FirstName) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.personalDetail.LastName), 1)
                        ]),
                        (_ctx.personalDetail.NickName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "( " + _toDisplayString(_ctx.personalDetail.NickName) + " )", 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.personalDetail.Email), 1),
                        (_ctx.personalDetail.Title)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.personalDetail.Title), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.uploadImage,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.uploadImage) = $event)),
      persistent: "",
      "max-width": "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { "align-self": "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { justify: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          md: "12",
                          sm: "12",
                          cols: "12",
                          align: "center"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("input", {
                              ref: "input",
                              type: "file",
                              name: "image",
                              accept: "image/*",
                              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setImage && _ctx.setImage(...args)))
                            }, null, 544),
                            _createVNode(_component_VuePictureCropper, {
                              boxStyle: {
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'transparent',
                    margin: 'auto',
                  },
                              img: _ctx.imageData,
                              options: {
                    viewMode: 1,
                    dragMode: 'move',
                    aspectRatio: 1,
                    cropBoxResizable: false,
                  },
                              presetMode: {
                    mode: 'round',
                    width: 400,
                    height: 400,
                  }
                            }, null, 8, ["img"]),
                            _createVNode(_component_vue_cropper, {
                              ref: "cropper",
                              src: _ctx.imageData,
                              preview: ".preview"
                            }, null, 8, ["src"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          md: "12",
                          sm: "12",
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { align: "center" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      class: "ml-1 mr-1",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.zoom(0.1))),
                                      icon: "mdi-magnify-plus-outline"
                                    }),
                                    _createVNode(_component_v_btn, {
                                      class: "ml-1 mr-1",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.zoom(-0.1))),
                                      icon: "mdi-magnify-minus-outline"
                                    }),
                                    _createVNode(_component_v_btn, {
                                      class: "ml-1 mr-1",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.rotate(90))),
                                      icon: "mdi-rotate-right"
                                    }),
                                    _createVNode(_component_v_btn, {
                                      class: "ml-1 mr-1",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.rotate(-90))),
                                      icon: "mdi-rotate-left"
                                    }),
                                    _createVNode(_component_v_btn, {
                                      class: "ml-1 mr-1",
                                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.flipH())),
                                      icon: "mdi-flip-horizontal"
                                    }),
                                    _createVNode(_component_v_btn, {
                                      class: "ml-1 mr-1",
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.flipV())),
                                      icon: "mdi-flip-vertical"
                                    }),
                                    _createVNode(_component_v_btn, {
                                      class: "ml-1 mr-1",
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.reset())),
                                      icon: "mdi-refresh"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { justify: "center" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, { onClick: _ctx.showFileChooser }, {
                                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createTextVNode(" Choose an image ")
                                  ])),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.fileMessage && _ctx.fileMessage.length > 0)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          class: "mt-7"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileMessage, (message) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: message,
                                class: "mb-0 error--text"
                              }, _toDisplayString(message), 1))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                (!_ctx.isHiringmanager)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      color: "secondary",
                      onClick: _ctx.setImages
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createTextVNode("mdi-check")
                          ])),
                          _: 1
                        }),
                        _cache[21] || (_cache[21] = _createTextVNode(" Accept"))
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (!_ctx.isHiringmanager)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      color: "primary",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.uploadImage = false))
                    }, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createTextVNode("Cancel")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.showPhotoRequirements)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: _ctx.showPhotoRequirements,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showPhotoRequirements) = $event)),
          "max-width": "500",
          onKeydown: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.showPhotoRequirements = false), ["esc"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InformationDialog, {
              title: _ctx.informationDialogTitle,
              messages: _ctx.photoReqirements,
              onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showPhotoRequirements = false))
            }, null, 8, ["title", "messages"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}